import { Controller } from "@hotwired/stimulus"

// The Send to TEAM install button (Send_To_TEAM_Plan.md). Its link is the
// bookmarklet itself, which belongs on the bookmarks bar; clicked here it
// would only run inside TEAM, so a click explains how to drag it instead
// (committee seat B, 2026-10-01). Dragging is untouched.
export default class extends Controller {
  static targets = ["explanation"]

  explain(event) {
    event.preventDefault()
    this.explanationTarget.classList.remove("hidden")
  }
}
